// Insights open with a `#` or `##` heading
export const HEADING_PREFIX = /^#{1,2}\s+/;

export function splitFirstHeading(content: string): {
  heading: string | null;
  rest: string;
} {
  const lines = content.split("\n");
  let firstNonBlankIndex = -1;

  for (let i = 0; i < lines.length; i += 1) {
    if (lines[i]?.trim() !== "") {
      firstNonBlankIndex = i;
      break;
    }
  }

  const firstNonBlankLine =
    firstNonBlankIndex === -1 ? undefined : lines[firstNonBlankIndex];

  if (
    firstNonBlankIndex === -1 ||
    !firstNonBlankLine ||
    !HEADING_PREFIX.test(firstNonBlankLine)
  ) {
    return { heading: null, rest: content };
  }

  const heading = firstNonBlankLine;
  const rest = [
    ...lines.slice(0, firstNonBlankIndex),
    ...lines.slice(firstNonBlankIndex + 1),
  ]
    .join("\n")
    .trim();

  return { heading: heading ?? null, rest };
}
